/* eslint-disable */
import React, {useState} from "react";
/*component*/
import Modal from '../../component/Inc/Modal';
import ClassRegister from "../../component/student/ClassRegister";
import PopPay from "./_PopPay";//결제 팝업
import PopScheduleManagement from "./_PopScheduleManagement";//면접일정 관리

function PopClassRegister(props) {
  const { open, close } = props;
  const [modalOpenPay, setModalOpenPay] = useState(false);//결제 팝업
  const [modalOpenScheduleManagement, setModalOpenScheduleManagement] = useState(false);//면접일정 팝업
  return (
    <>
    <Modal open={open} close={close}  type="pop_class_register" popSize="xl" >
      <h2 className='pop_tit'>수업등록</h2>
      <div className="content_container scroll ">
        <ClassRegister/>
      </div>
      <div className="btn_container">
        <button onClick={() => {setModalOpenScheduleManagement(true)}} className="com_btn orange xs">등록</button>
        <button onClick={() => {setModalOpenPay(true)}} className="com_btn orange xs">결제하기</button>
      </div>
    </Modal>
    <PopPay open={modalOpenPay} close={() => setModalOpenPay(false)} />{/*결제*/}
    <PopScheduleManagement open={modalOpenScheduleManagement} close={() => setModalOpenScheduleManagement(false)} />{/*면접일정*/}
    </>
  );
}

export default PopClassRegister;